/** Load more button **/
setTimeout(function () {
  $(document).ready(function () {
    $(".has_load_more_button.social-media-section-one .two-blocks-per-row")
      .slice(0, 4)
      .show();
    $("#loadMoresocial-media-section-one").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.social-media-section-one .two-blocks-per-row:hidden"
      )
        .slice(0, 4)
        .slideDown();
      if (
        $(
          ".has_load_more_button.social-media-section-one .two-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMoresocial-media-section-one").css("display", "none");
      }
    });

    $(".has_load_more_button.social-media-section-two .three-blocks-per-row")
      .slice(0, 6)
      .show();
    $("#loadMoresocial-media-section-two").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.social-media-section-two .three-blocks-per-row:hidden"
      )
        .slice(0, 6)
        .slideDown();
      if (
        $(
          ".has_load_more_button.social-media-section-two .three-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMoresocial-media-section-two").css("display", "none");
      }
    });

    $(".has_load_more_button.social-media-section-three .three-blocks-per-row")
      .slice(0, 6)
      .show();
    $("#loadMoresocial-media-section-three").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.social-media-section-three .three-blocks-per-row:hidden"
      )
        .slice(0, 6)
        .slideDown();
      if (
        $(
          ".has_load_more_button.social-media-section-three .three-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMoresocial-media-section-three").css("display", "none");
      }
    });

    $(".has_load_more_button.smart-screens-two .two-blocks-per-row")
      .slice(0, 4)
      .show();
    $("#loadMoresmart-screens-two").on("click", function (e) {
      e.preventDefault();
      $(".has_load_more_button.smart-screens-two .two-blocks-per-row:hidden")
        .slice(0, 4)
        .slideDown();
      if (
        $(".has_load_more_button.smart-screens-two .two-blocks-per-row:hidden")
          .length == 0
      ) {
        $("#loadMoresmart-screens-two").css("display", "none");
      }
    });

    //Styleguides page section three
    $(".has_load_more_button.styleguide-section-three .three-blocks-per-row")
      .slice(0, 6)
      .show();
    $("#loadMorestyleguide-section-three").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.styleguide-section-three .three-blocks-per-row:hidden"
      )
        .slice(0, 6)
        .slideDown();
      if (
        $(
          ".has_load_more_button.styleguide-section-three .three-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMorestyleguide-section-three").css("display", "none");
      }
    });

    //Styleguides page section four
    $(".has_load_more_button.styleguide-section-four .three-blocks-per-row")
      .slice(0, 6)
      .show();
    $("#loadMorestyleguide-section-four").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.styleguide-section-four .three-blocks-per-row:hidden"
      )
        .slice(0, 6)
        .slideDown();
      if (
        $(
          ".has_load_more_button.styleguide-section-four .three-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMorestyleguide-section-four").css("display", "none");
      }
    });

    //Styleguides page section seven
    $(".has_load_more_button.styleguide-section-seven .two-blocks-per-row")
      .slice(0, 6)
      .show();
    $("#loadMorestyleguide-section-seven").on("click", function (e) {
      e.preventDefault();
      $(
        ".has_load_more_button.styleguide-section-seven .two-blocks-per-row:hidden"
      )
        .slice(0, 6)
        .slideDown();
      if (
        $(
          ".has_load_more_button.styleguide-section-seven .two-blocks-per-row:hidden"
        ).length == 0
      ) {
        $("#loadMorestyleguide-section-seven").css("display", "none");
      }
    });
  });
}, 2000);
